import React, {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import commonHeader from "../../assets/img/commonHeader.png";
import notice from "../../assets/img/notice.png";
import commonBack from "../../assets/img/commonBack.png";
import axios from '../../services/axiosInstance';
import DOMPurify from "dompurify";
import {useTranslation} from "react-i18next";
import Linkify from "react-linkify";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";



function UserNoticeDtPg() {

    const { t } = useTranslation();
    const {seqNum} = useParams();
    const navigate = useNavigate();
    const [theme] = useTheme();

    const [noticeDtData, setNoticeDtData] = useState([]);
    const [photoList, setPhotoList] = useState([]);

    const selectDtData = () => axios({
        method: 'get',
        url: '/notice/selectNoticeData/',
        params: {
            seqNum: seqNum
        }
    })
        .then((response) => {
            setNoticeDtData(response.data);
            setPhotoList(response.data.noticePhotoDTO)
        })

    useState(() => {
        if (seqNum) {
            selectDtData();
        }
    }, [])

    const sanitizeHTML = (rawHTML) => {
        if (!rawHTML) return "";
        return DOMPurify.sanitize(rawHTML.replace(/\n/g, '<br>'));
    };

    const formatDate = (dateStr) => {
        if (dateStr?.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" alt="notice" src={commonHeader}/>
                    <p className="up-head-title">{t(`NtdtHeader`)}</p>
                </div>
                <div className="up-head-spacer"/>
                <div className="up-head-back" onClick={() => navigate("/UserNoticePg")}>
                    <img className="up-invert" style={{width: "24px", height: "24px", opacity: "0.7"}} alt="back" src={commonBack}/>
                </div>
            </div>

            <div className="up-card" style={{padding: "20px 22px"}}>
                <div className="up-detail-head">
                    <div className="up-detail-title">
                        <img className="up-invert" alt="noticeTitle" src={notice}/>
                        <p className="t">{noticeDtData?.title}</p>
                    </div>
                    <div className="up-detail-meta">
                        <span>{noticeDtData?.regNm}</span>
                        <span>{formatDate(noticeDtData?.regDate)}</span>
                    </div>
                </div>

                <div className="up-detail-content">
                    <Linkify
                        componentDecorator={(decoratedHref, decoratedText, key) => (
                            <a target="blank" href={decoratedHref} key={key}>
                                {decoratedText}
                            </a>
                        )}
                    >
                        {DOMPurify.sanitize(noticeDtData?.content)}
                    </Linkify>
                </div>

                <div className="up-detail-imgs">
                    {photoList && photoList.map((photo, index) => (
                        <img key={index}
                             src={"https://toeloperfile.s3.ap-northeast-2.amazonaws.com/writePhoto/" + photo.fileNm}
                             alt="photoImg"/>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default UserNoticeDtPg
